import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import * as authenticationAction from '../../store/actions/authenticationAction';

class Logout extends Component {
   componentDidMount() {
      this.props.onLogout();
   }

   render() {
      return <Redirect to="/" />;
   }
}

const mapDispatchToProps = dispatch => {
   return {
      onLogout: () => dispatch(authenticationAction.logout())
   };
};

export default connect(null, mapDispatchToProps)(Logout);